import { useContext } from 'react';

import { TranslationContext } from 'contexts/TranslationContext';
export { TranslationsKeys } from 'types/translation';

/*
  - example:
      const t = useTranslate();
      t('path/to/translation');

      from: { 'path/to/translation': 'Some content' }
      returns: 'Some content'

  - example with translation-template:
      const t = useTranslate();
      t('path/to/template', { replacementExample: 'content' })

      from: { 'path/to/template: 'Replace {replacementExample} in this template' }
      returns: 'Replace content in this template'

*/

export const useTranslate = () => {
  const translationsContext = useContext(TranslationContext);

  return translationsContext;
};
